import { render, staticRenderFns } from "./CookingCheck.vue?vue&type=template&id=64816d8a&"
import script from "./CookingCheck.vue?vue&type=script&lang=js&"
export * from "./CookingCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports